<div class="animated fadeIn container-fluid">

    <form class="needs-validation" [formGroup]="form" novalidate>
        <h4>Editar Solicitud de Exportación {{form?.value?.Codigo}}</h4>

        <div class="row">
            <div class="col-md-12">
                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedDatosSolicitud = !isCollapsedDatosSolicitud" [attr.aria-expanded]="!isCollapsedDatosSolicitud"
                       aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Datos Solicitud
                            <i *ngIf="isCollapsedDatosSolicitud" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosSolicitud" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">

                        <div class="collapse group-campos" id="isCollapsedDatosSolicitud" [ngbCollapse]="isCollapsedDatosSolicitud">

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpCodigoEx">Código Solicitud</label>
                                    <input readonly formControlName="CodigoSolicitudEx" name="CodigoSolicitudEx" title=""
                                           class="form-control" id="inpCodigoEx" type="text" value="">

                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpNumeroCertificadoEx">Número Certificado</label>
                                    <input readonly formControlName="NumeroCertificadoEx" name="NumeroCertificadoEx" title=""
                                           class="form-control" id="inpNumeroCertificadoEx" type="text" value="">

                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="intDescripcion">Fecha de Envío</label>
                                    <input formControlName="FechaEnvio" name="FechaEnvio" class="form-control" readonly inputStyleClass="form-control" [ngClass]="displayFieldCss('FechaEnvio')" value="">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label required-field" for="IdEstadoSolicitudEx">Estado Solicitud</label>
                                    <ng-select appendTo="body"
                                               [items]="estadoSolicitudEx"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdEstadoSolicitudEx"
                                               loadingText="Cargando..."
                                               [loading]="(!estadoSolicitudEx || estadoSolicitudEx.length === 0)"
                                               placeholder="-- Seleccione un Estado --"
                                               [ngClass]="displayFieldCssNgSelect('IdEstadoSolicitudEx')"
                                               notFoundText="Estado no encontrado"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">
                                                <span>
                                                    <img class="estado-icono" src="{{ item.Id | IconoEstadoSolicitudEx }}" container="body" ngbTooltip="{{ item.Descripcion }}" />
                                                </span>
                                                {{ item.Descripcion }}
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                    <div id="validationIdEstadoSolicitudExFeedback" class="form-invalid" *ngIf="isFieldInvalid('IdEstadoSolicitudEx', 'cannotBeNullOrZero', false)">
                                        Estado obligatorio.
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>


            </div>
        </div>
        <div class="row" *ngIf="habilitarVentanaReasignacionPcf">
            <div class="col-md-12">
                <h4>Reasignación de PCF</h4>
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos para la reasignación de PCF
                        </div>
                    </a>

                    <div class="card-body-detalle mb-3">
                        <div>
                            <div class="row">

                                <!-- Punto de Inspección -->
                                <div class="form-group col-md-4">
                                    <label class="col-form-label required-field" for="intEstado">Punto de Inspección</label>
                                    <ng-select [items]="listPuntoInspeccion"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPuntoInspeccion"
                                               loadingText="Cargando..."
                                               [loading]="!listPuntoInspeccion"
                                               notFoundText="Punto de Inspección no encontrado"
                                               placeholder="-- Seleccione un Punto de Inspección --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdPuntoInspeccion')"
                                               (change)="onSelectPuntoInspeccion()">
                                    </ng-select>
                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPuntoInspeccion','required')">
                                        Punto de Inspección es obligatorio
                                    </div>
                                </div>

                                <!-- Ubicación -->
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" [ngClass]="{ 'required-field' : campoUbicacion }" for="">Ubicación</label>
                                    <ng-select [items]="listUbicacion"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdUbicacion"
                                               loadingText="Cargando..."
                                               [loading]="(!listUbicacion && (form.value.IdPuntoInspeccion > 0))"
                                               notFoundText="Ubicación no encontrada"
                                               placeholder="-- Seleccione Ubicación o Instalación Autorizada --"
                                               [ngClass]="displayFieldCssNgSelect('IdUbicacion')"
                                               clearAllText="Eliminar selección"
                                               (change)="onSelectUbicacion()">
                                    </ng-select>
                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdUbicacion','required')">
                                        Ubicación o Instalación Autorizada son obligatorias
                                    </div>
                                </div>

                                <!-- Instalacion Autorizada -->
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" [ngClass]="{ 'required-field' : campoInstalacion }" for="">Instalación Autorizada</label>
                                    <ng-select [items]="listInstalacionAutorizada"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdInstalacionAutorizada"
                                               loadingText="Cargando..."
                                               [loading]="(!listInstalacionAutorizada && (form.value.IdPuntoInspeccion > 0))"
                                               notFoundText="Instalación Autorizada no encontrada"
                                               placeholder="-- Seleccione Ubicación o Instalación Autorizada --"
                                               [ngClass]="displayFieldCssNgSelect('IdInstalacionAutorizada')"
                                               clearAllText="Eliminar selección"
                                               (change)="onSelectInstalacionAutorizada()">
                                    </ng-select>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdInstalacionAutorizada','required')">
                                        Instalación Autorizada o Ubicación son obligatorias
                                    </div>
                                </div>

                                <!--Hora Reasignacion-->
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="IdIntervaloHoras">Hora de Reasignación</label>
                                    <ng-select [items]="listHoras"
                                               bindLabel="HoraInicio"
                                               bindValue="Id"
                                               formControlName="IdIntervaloHoras"
                                               loadingText="Cargando..."
                                               [loading]="!listHoras"
                                               notFoundText="Horas no encontradas"
                                               placeholder="-- Seleccione una Hora de Reasignación --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdIntervaloHoras')">
                                    </ng-select>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

